/**
 * Sanitizes numeric input by:
 * 1. Removing non-numeric characters (except dots)
 * 2. Removing extra decimal points (keeping only the first one)
 * 3. Removing leading zeros while preserving single zero
 */
export function sanitizeNumericInput(input: string): string {
    // 1. Replace decimal comma to dot
    let sanitized = input.replace(',', '.');

    // 2. Remove non-numeric characters
    sanitized = sanitized.replace(/[^0-9.]/g, '');

    // 3. Remove extra decimal points
    sanitized = removeExtraDecimalPoints(sanitized);

    // 4. Normalize leading zeros
    sanitized = normalizeLeadingZeros(sanitized);

    return sanitized;
}

/**
 * Removes extra decimal points, keeping only the first one
 */
export function removeExtraDecimalPoints(value: string): string {
    const parts = value.split('.');
    value = parts.length > 2 ? `${parts[0]}.${parts.slice(1).join('')}` : value;
    const [left, right] = value.split('.');

    if (!right) {
        return value;
    }

    return `${left === '' ? '0' : left}.${right === undefined || right === '' ? '0' : right}`;
}

/**
 * Normalizes leading zeros:
 * - Preserves "0" if the string consists only of zeros
 * - Removes leading zeros otherwise
 */
export function normalizeLeadingZeros(value: string): string {
    value = /^0+$/.test(value) ? '0' : value.replace(/^0+/, '');

    return value.startsWith('.') ? '0' + value : value;
}
